export default __webpack_public_path__ + "static/media/clouds-sm@1x.8847c827.webp";